import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("BilheteNotaPremiadaContribuinteTO")
export class BilheteNotaPremiadaContribuinteTO {

  periodo: String;

  numero: number;

  ativo: boolean;

  motivoCancelamento: string;

}
